/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FolderCto } from '../../models/folder-cto';

export interface GetCompanyFolders$Json$Params {
  companyId: string;
}

export function getCompanyFolders$Json(http: HttpClient, rootUrl: string, params: GetCompanyFolders$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FolderCto>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyFolders$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FolderCto>>;
    })
  );
}

getCompanyFolders$Json.PATH = '/company/{companyId}/folders';
